import * as React from 'react'
import { Column } from '../types'
import I18n from '../../../../libs/i18n'

interface NumberSettingsProps {
  column: Column
  onUpdate: (updates: Partial<Column>) => void
}

export default function NumberSettings({
  column,
  onUpdate,
}: NumberSettingsProps) {
  const settings = column.settings || {}
  const min = settings.min as number | undefined
  const max = settings.max as number | undefined

  const updateSetting = (key: string, value: number | undefined) => {
    onUpdate({
      settings: { ...column.settings, [key]: value },
    })
  }

  return (
    <div className="d-flex align-items-center flex-wrap">
      <div className="mr-3 mb-1">
        <label className="small text-muted mr-1 mb-0">{I18n.t('project_groups.columns_editor.min')}</label>
        <input
          type="number"
          className="form-control form-control-sm d-inline-block"
          style={{ width: 80 }}
          value={min ?? ''}
          onChange={(e) =>
            updateSetting('min', e.target.value ? Number(e.target.value) : undefined)
          }
        />
      </div>
      <div className="mb-1">
        <label className="small text-muted mr-1 mb-0">{I18n.t('project_groups.columns_editor.max')}</label>
        <input
          type="number"
          className="form-control form-control-sm d-inline-block"
          style={{ width: 80 }}
          value={max ?? ''}
          onChange={(e) =>
            updateSetting('max', e.target.value ? Number(e.target.value) : undefined)
          }
        />
      </div>
    </div>
  )
}
